import React from 'react';
import { withComponentName } from '../../../../common/ComponentNameContext';
import { TYPE_DISABLE } from '../../../../common/sync-component/Const';
import { syncComponentSelector } from '../../../../helpers/Common';
import EventEmitter, {
  SYNC_COMPONENT_SEARCH,
} from '../../../../helpers/EventEmitter';
import { REDUCER_NAME, setCondition } from '../../reducer';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from './../../../../app/commonReducer';
import { withComponentId } from '../../../../common/ComponentIdContext';
import './index.scss';
import IndexSummary from './index-summary';
import { SearchFilter } from '../../../../common/search-filter';

class SearchBox extends React.PureComponent {
  componentDidMount() {
    EventEmitter.subscribe(SYNC_COMPONENT_SEARCH, this.onSyncSearch);
  }

  componentWillUnmount() {
    EventEmitter.unsubscribe(SYNC_COMPONENT_SEARCH, this.onSyncSearch);
  }

  onSyncSearch = data => {
    const { syncType, changeCode, componentId } = this.props;
    if (
      syncType === TYPE_DISABLE ||
      data.syncType !== syncType ||
      data.search.isIndex ||
      data.search.isDerivatives ||
      !data.search.isTicker
    ) {
      return;
    }
    changeCode(componentId, data.search);
  };

  clickItemSearch = code => {
    const { changeCode, componentId, syncType } = this.props;

    changeCode(componentId, code);
    if (syncType === TYPE_DISABLE) {
      return;
    }
    EventEmitter.dispatch(SYNC_COMPONENT_SEARCH, {
      syncType: syncType,
      search: code,
    });
  };

  render() {
    const {
      searchParams = {},
      topContent,
      topContentRealTime,
      listOrganizationByOrganCode,
    } = this.props;

    const currentSearch =
      listOrganizationByOrganCode[searchParams.code] || searchParams;

    return (
      <div className="search-box-wrapper my-other-step">
        <SearchFilter
          schema={[
            { key: 'displayCode', className: 'w-20' },
            { key: 'codeName', className: 'w-55 text-truncate' },
            {
              key: 'exchange',
              className: 'w-25 text-right',
              render: text => text.toUpperCase(),
            },
          ]}
          listKeyFilter={['displayCode', 'codeName']}
          mainKey={'code'}
          sortKey={'displayCode'}
          getListSearchFromRedux={state =>
            state[COMMON_REDUCER_NAME].listOrganizationSearch
          }
          currentSearch={currentSearch}
          clickItemSearch={this.clickItemSearch}
          customWidth={170}
        />
        <IndexSummary
          topContent={topContent}
          topContentRealTime={topContentRealTime}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, { componentId, componentName }) => {
  return {
    listOrganizationByOrganCode:
      state[COMMON_REDUCER_NAME].listOrganizationByOrganCode,
    searchParams:
      state[REDUCER_NAME].listMultiComponent[componentId].searchParams,
    topContent: state[REDUCER_NAME].listMultiComponent[componentId].topContent,
    topContentRealTime:
      state[REDUCER_NAME].listMultiComponent[componentId].topContentRealTime,
    syncType: syncComponentSelector(state, componentName, componentId),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    changeCode: (componentId, params) =>
      dispatch(setCondition(componentId, params)),
  };
};

export default compose(
  withComponentId,
  withComponentName,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(SearchBox);
